import * as React from "react";
import { FormGroup, ControlLabel, HelpBlock } from "components/bootstrap";
import ViewsQueryInput from "views/components/searchbar/ViewsQueryInput";
const noOpValidate = () => Promise.resolve({});
const noOpExecute = () => {
};
const HELP_TEXT = "Optional query to filter source messages. Leave blank to use all messages.";
const AnomalyQueryInput = ({ controlId, value, onChange, streams }) => /* @__PURE__ */ React.createElement(FormGroup, { controlId }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Search Query ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")), /* @__PURE__ */ React.createElement(
  ViewsQueryInput,
  {
    value,
    onChange,
    name: "query",
    inputId: controlId,
    placeholder: HELP_TEXT,
    streams,
    isValidating: false,
    validate: noOpValidate,
    onExecute: noOpExecute
  }
), /* @__PURE__ */ React.createElement(HelpBlock, null, HELP_TEXT));
export default AnomalyQueryInput;
